import {apiFetch} from '../_helpers';


export const purchasesService = {
    getAll,
    get
};


function getAll(params) {
    let str = Object.entries(params).map(([key, val]) => `${key}=${val}`).join('&');

    return apiFetch("transactions/?" + str);
}


function get(pk) {
    return apiFetch("transactions/"+pk+"/");
}